export const toProperCase = (s: string) => s[0].toUpperCase() + s.slice(1);

export const PHONE_REGEX = /^(?:\+\d{1,3}[\s-]?)?(?:\d{3}\)?[\s-]?\d{3}[\s-]?\d{4})$/;
export const EMAIL_REGEX =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const OIB_REGEX = /^\d{11}$/;
export const USERNAME_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/;
export const PASSWORD_REGEX = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[\d])(?=.*?[#?!@$%^&*,.:;-]).{8,}$/;

export const isValidPhoneNumber = (phone?: string): boolean => {
    return !phone || PHONE_REGEX.test(phone);
};

export const isValidEmail = (email?: string): boolean => {
    return !email || EMAIL_REGEX.test(email);
};

export const isEmptyOrWhitespace = (value?: string): boolean => {
    return !value || value.trim().length === 0;
};

export const isValidOib = (oib?: string): boolean => {
    if (!oib || !OIB_REGEX.test(oib)) {
        return false;
    }

    let checksum = 10;
    for (let i = 0; i < 10; i++) {
        checksum += parseInt(oib[i], 10);
        checksum %= 10;
        if (checksum === 0) checksum = 10;
        checksum *= 2;
        checksum %= 11;
    }

    const controlDigit = (11 - checksum) % 10;
    return controlDigit === parseInt(oib[10], 10);
};

export const isValidPassword = (password?: string): boolean => {
    return !password || PASSWORD_REGEX.test(password);
};
